import { render, staticRenderFns } from "./caseTitleText.vue?vue&type=template&id=0f9b9ce5&lang=pug"
import script from "./caseTitleText.vue?vue&type=script&lang=js"
export * from "./caseTitleText.vue?vue&type=script&lang=js"
import style0 from "./caseTitleText.vue?vue&type=style&index=0&id=0f9b9ce5&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports